<template>
  <div class="clickable">
    <div class="msg-title">
      <div class="is-pulled-right">
        <a class="button is-small is-warning is-pulled-right" @click="deleteMsg">
          <i class="fa fa-trash"></i>
        </a>
        <div class="p-1 is-pulled-right">{{ msg.created_on | human_date }}</div>
      </div>
      <div class="title-bar" @click="openBox">
                <span class="icon" v-if="msg.read">
                  <i class="fa fa-envelope-open"></i>
                </span>
        <span class="icon" v-if="!msg.read">
                  <i class="fa fa-envelope"></i>
                </span>
        <span style="word-wrap:anywhere;">{{ msg.title }}</span>
      </div>
    </div>
    <div class="msg-content" v-if="opened">{{ msg.text }}</div>
  </div>
</template>

<script>
import {gqlMutation} from '@/gqlClient.js'
import MESSAGE_MARK_READ from '@/gql/mutations/messageMarkRead.graphql'
import MESSAGE_DELETE from '@/gql/mutations/messageDelete.graphql'

export default {
  name: "Message",
  props: {
    msg: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      opened: false
    }
  },
  methods: {
    openBox() {
      this.opened = !this.opened
      this.markRead()
    },
    markRead() {
      if (!this.msg.read) {
        gqlMutation(MESSAGE_MARK_READ, {uid: this.msg.uid})
      }
    },
    deleteMsg() {
      gqlMutation(MESSAGE_DELETE, {uid: this.msg.uid})
    }
  }
}
</script>

<style lang="scss" scoped>
.msg-title {
  font-weight: bold;
  /*height:30px;*/
}

.title-bar {
  width: calc(100% - 50px);
}

.clickable {
  cursor: pointer;
}

.msg-content {
  font-size: 0.9em;
  border-top: 1px solid #F2F2F2;
  margin-left: -15px;
  margin-right: -15px;
  padding: 10px;
  white-space: pre-line;
}
</style>